import React from 'react'
import {
  AuthenticatedTemplate,
  UnauthenticatedTemplate,
} from '@azure/msal-react'
import { useConfiguration } from './providers/ConfigurationContext'
import { AppInsightsContext } from '@microsoft/applicationinsights-react-js'
import { type ApplicationInsights } from '@microsoft/applicationinsights-web'
import { getAppInsights } from '../monitoring/AppInsights'
import { useEnsureDriver } from '../features/user/useEnsureDriver'
import { FeatureFlagsProvider } from './providers/FeatureFlagContext'
import { LoginPage } from '../pages/LoginPage'
import AppRouter from './AppRouter'
import { ColorModeProvider } from '../design/ColorModeProvider'

const DriverCheck: React.FC<{ appInsights: ApplicationInsights }> = ({
  appInsights,
}) => {
  useEnsureDriver(appInsights)
  return null
}

const App: React.FC = () => {
  const config = useConfiguration()
  const { reactPlugin, appInsights } = getAppInsights(
    config.applicationInsightsConnectionString
  )
  return (
    <div className="App">
      <header className="App-header"></header>
      <React.Fragment>
        <AuthenticatedTemplate>
          <DriverCheck appInsights={appInsights} />
          <FeatureFlagsProvider>
            <AppInsightsContext.Provider value={reactPlugin}>
              <AppRouter />
            </AppInsightsContext.Provider>
          </FeatureFlagsProvider>
        </AuthenticatedTemplate>
        <UnauthenticatedTemplate>
          <ColorModeProvider>
            <LoginPage>
              <></>
            </LoginPage>
          </ColorModeProvider>
        </UnauthenticatedTemplate>
      </React.Fragment>
    </div>
  )
}

export default App
